"use strict";

var _dateFormat = require("./constants/dateFormat");

var getMoment = require('./getMoment');

var getMaxMoment = require('./getMaxMoment');

var formatDate = require('./formatDate');

module.exports = {
  getMoment: getMoment,
  getMaxMoment: getMaxMoment,
  formatDate: formatDate,
  DATE_FORMAT: _dateFormat.DATE_FORMAT
};